var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesEmailTracking = function SvgYeswareSalesEmailTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.988,
    width: 80,
    height: 80,
    rx: 25.192,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.623 35.246a.943.943 0 0 0-1.445-.8L45.485 46.059a8.526 8.526 0 0 1-8.994 0L19.794 34.447a.932.932 0 0 0-.955-.027.94.94 0 0 0-.486.826v15.992a5.659 5.659 0 0 0 5.658 5.659h33.953a5.659 5.659 0 0 0 5.659-5.659V35.246Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.623 28.762a5.659 5.659 0 0 0-5.658-5.658H24.011a5.659 5.659 0 0 0-5.66 5.659.275.275 0 0 0 .133.237l20.994 14.306a2.838 2.838 0 0 0 2.995 0L63.48 29a.282.282 0 0 0 .143-.238Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareSalesEmailTracking;